import React, { useRef } from "react";
import styles from "./Canvas.module.css";

export default function Canvas({
  page,
  pageIndex,
  pageCount,
  panel,
  panelIndex,
  panelCount,
  onImageChange,
}) {
  const fileInputRef = useRef(null);

  if (!panel) {
    return (
      <div className={styles.canvasArea}>
        <div className={styles.empty}>Agrega un frame para empezar.</div>
      </div>
    );
  }

  const handleFile = (file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => onImageChange(panel.id, reader.result);
    reader.readAsDataURL(file);
  };

  return (
    <div className={styles.canvasArea}>
      <div className={styles.grid} />

      <div className={styles.frameWrapper}>
        <div className={styles.overlayTopLeft}>
          <span className="text-mono-sm">
            PÁGINA {pageIndex + 1}/{pageCount}
          </span>
          <span className="text-mono-sm">
            FRAME {panelIndex + 1}/{panelCount}
          </span>
        </div>

        <div className={styles.overlayTopRight}>
          <span className="text-mono-sm">{page.title}</span>
        </div>

        <img src={panel.image} alt={panel.text} className={styles.image} />

        <button
          className={`${styles.replaceButton} text-label-sm`}
          onClick={() => fileInputRef.current?.click()}
        >
          <span className="material-symbols-outlined" style={{ fontSize: 16 }}>
            upload
          </span>
          Reemplazar imagen
        </button>
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={(e) => {
            handleFile(e.target.files?.[0]);
            e.target.value = "";
          }}
        />

        <div className={styles.overlayBottom}>
          <span className="text-mono-sm">{panel.duration?.toFixed(1)}s</span>
        </div>
      </div>
    </div>
  );
}
